import { CATEGORY_URI } from "src/shared/config";
import { ApiResponse } from "src/shared/types";
import appFetch from "src/shared/fetch";
import { getServiceName, getXClientIdHeader } from "src/utils/getservicename";

type GetCategoriesParam = {
  category: string;
  timeTab: string;
  shouldFetchFreshData?: boolean;
};

type SearchCategoriesParam = {
  timeTab: string;
  text: string;
  superCategory: string;
};

export const getCategories = ({ category, timeTab, shouldFetchFreshData }: GetCategoriesParam): ApiResponse => {
  const queryParams = {
    superCategory: category,
    isFetchMain: "false",
    timeTab,
  };
  const headers = shouldFetchFreshData ? { "X-Clear-Cache": "true", ...getXClientIdHeader() } : getXClientIdHeader();
  return appFetch.get(CATEGORY_URI, {
    params: queryParams,
    headers,
  });
};

export const searchCategories = ({ timeTab, text, superCategory }: SearchCategoriesParam): ApiResponse => {
  const queryParams = {
    searchText: text,
    notes_enabled: "false",
    superCategory: superCategory,
    isFetchMain: "false",
    timeTab,
  };
  return appFetch.get(CATEGORY_URI, { params: queryParams });
};
